import { Box, Typography } from "@mui/material";
import { AppointmentParticipant } from "./appointmentParticipantTypes";
import { hasContactAccess } from "./appointmentParticipantUtils";

type Props = {
  participant: AppointmentParticipant;
  showName?: boolean;
};

const ParticipantContactStack = ({ participant, showName = true }: Props) => {
  const showContact = hasContactAccess(participant);

  return (
    <Box>
      {showName && (
        <Typography variant="body2" fontWeight={500} color="text.primary">
          {participant.name}
        </Typography>
      )}
      {showContact && participant.email && (
        <Typography variant="caption" color="text.secondary" display="block">
          {participant.email}
        </Typography>
      )}
      {showContact && participant.phoneNumber && (
        <Typography variant="caption" color="text.secondary" display="block">
          {participant.phoneNumber}
        </Typography>
      )}
    </Box>
  );
};

export default ParticipantContactStack;
